<template>
  <div class="tan_needGz_portraitWrap" style="z-index: 999999 !important;">
    <div class="needGZ_TanWrap" v-if="tan_needGZ_single && allData" style="z-index: 999999 !important;">
      <div class="needGZ_Tan bgF3F4F7 needGZ_One_Tan">
        <div class="needGZ_Top">
          <div class="time">{{allData.buAndFlName}}</div>
          <div class="chazi" @click="tan_needGZ_single = false">X</div>
        </div>

        <div class="needGZ_Cont" :style="{maxHeight: innerHeight + 'px',overflow: 'auto'}">
          <!-- 多日独有 -->
          <div v-if="nowType == 7">
            <!-- 头部日历等 -->
            <!-- <div class="topright">
              <div class="saiBtn">
                <a-popover
                  v-model="showCalendar"
                  overlayClassName="calendar-name"
                  placement="bottom"
                >
                  <template slot="content">
                    <a-calendar
                      :fullscreen="false"
                      :defaultValue="$moment(activeDate, 'YYYY-MM-DD')"
                      :value="$moment(activeDate, 'YYYY-MM-DD')"
                      :validRange="[
                        $moment(
                          activeDates[activeDates.length - 1],
                          'YYYY-MM-DD'
                        ),
                        $moment(activeDates[0], 'YYYY-MM-DD'),
                      ]"
                      :disabledDate="getInvalidDates"
                      @panelChange="panelChange"
                      @select="changeDate"
                    >
                      <template slot="dateCellRender" slot-scope="value">
                        <div v-if="getDayData(value)">
                          <section>
                            <div class="calDot"></div>
                          </section>
                        </div>
                      </template>
                    </a-calendar>
                  </template>
                  <div
                    :class="{ actives: activeType == true }"
                    class="hoverBtns on"
                  >
                    {{
                      activeDate.slice(5, 7) + '月' + activeDate.slice(8) + '日'
                    }}
                    <a-icon type="calendar" />
                  </div>
                </a-popover>
              </div>
            </div> -->
            
            <!-- 头部日期下拉框 -->
            <a-select
              class="dateCont"
              ref="select"
              :value="top_date_selval"
              style="width: 120px;z-index: 999999 !important;"
              @change="handleChange_topDate"
              dropdown-class-name="dropdown-class"
            >
              <a-select-option :value="item.date" :key="index" v-for="(item,index) in topDateList" style="z-index: 999999 !important;">{{ item.date | dataChange(item.date)}}</a-select-option>
              <!-- <a-select-option :value="item.date" :key="index" v-for="(item,index) in topDateList">{{ item.date}}</a-select-option> -->
              <!-- <a-select-option :value="aaaa">{{ aaaa | dataChange(aaaa)}}</a-select-option> -->
            </a-select>
            
            <div class="needChangeWrap">
              <div class="needChangeTip">共有</div>
              <div class="needChangeTip colorFF7186" v-if="topDateList">{{ topDateList.length }}</div>
              <div class="needChangeTip">天发生了需关注的变化</div>
            </div>
          </div>


          <div class="needGZ_comTit">需关注的变化</div>
          
         
          <div class="needGZ_OneListWrap" v-if="allData">
            <!-- 呼吸情况 -->
            <div class="needGZ_OneList" v-if="allData.breathInfoTitleList && allData.breathInfoTitleList.length > 0">
              <div class="needGZ_OneList_topWrap" @click="hxqk_isExpand = !hxqk_isExpand">
                <div class="needGZ_OneList_top">
                  <img class="report_icon_notice_d" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                  <div class="phenomen">
                    <span :key="index" v-for="(item,index) in allData.breathInfoTitleList">
                      <span v-if="allData.breathInfoTitleList == 0">{{ item }}</span>
                      <span v-if="allData.breathInfoTitleList.length > 0 && index != allData.breathInfoTitleList.length-1">{{ item }}、</span>
                      <span v-if="allData.breathInfoTitleList.length > 0 && index == allData.breathInfoTitleList.length-1">{{ item }}</span>
                    </span>
                  </div>
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!hxqk_isExpand">
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="hxqk_isExpand">
                </div>
                <div class="oListTips" v-if="allData.breathInfo.deviateTheDay"  v-html="$options.filters.reMate2(allData.breathInfo.deviateTheDay.descLabel)"></div>
              </div>
              <!-- 弹窗展开内容 -->
              <div class="oneExpandCont" v-show="!allData.breathInfo.unSecretsDays && hxqk_isExpand">
                <div class="txjyWrap" v-if="allData.breathInfo.deviateTheDay">
                  <div class="txjyTit">提醒和建议</div>
                  <div class="txjyTit2">{{allData.breathInfo.deviateTheDay.remindAndSuggestLabel}}</div>
                </div>
                
                <!-- 呼吸率分布如下图 -->
                <div class="txjyWrap border_no mt10">
                  <div class="txjyTit txjyTit_after_blue" style="">呼吸率分布如下图：</div>
                  <div class="referVal">
                    <div class="referValLeft">
                      <div class="gangKuai2_border"></div>
                      <div class="gantTip">参考范围</div>
                    </div>
                    <div class="referValRight">
                      <div class="gantTip">横轴为呼吸率(次/分)</div>
                    </div>
                  </div>
                  <div id="ech_breathOne" style="height: 150px;"></div>
                  <div class="refer_comTit mt15" v-if="allData.breathInfo.secretsBreath">{{ allData.breathInfo.secretsBreath.descLabel }}</div>

                  <!-- 是否发生偏离 -->
                  <tan_needGz_portrait_botZheCont v-if="allData.breathInfo.secretsBreathDeviate" :haveChangeData="allData.breathInfo.secretsBreathDeviate"></tan_needGz_portrait_botZheCont>
                </div>
                <!-- 吸呼比分布 -->
                <div class="txjyWrap border_no mt10">
                  <div class="txjyTit txjyTit_after_blue mt15" style="">吸呼比分布如下图：</div>
                  <div class="referVal">
                    <div class="referValLeft">
                      <div class="gangKuai2_border"></div>
                      <div class="gantTip">参考范围</div>
                    </div>
                    <div class="referValRight">
                      <div class="gantTip">横轴为吸呼比</div>
                    </div>
                  </div>
                  <div id="ech_breathTwo" style="height: 150px;"></div>
                  <div class="refer_comTit mt15" v-if="allData.breathInfo.secretsInExRatio">{{ allData.breathInfo.secretsInExRatio.descLabel }}</div>

                  <!-- 是否发生偏离 -->
                  <tan_needGz_portrait_botZheCont v-if="allData.breathInfo.secretsInExRatioDeviate" :haveChangeData="allData.breathInfo.secretsInExRatioDeviate"></tan_needGz_portrait_botZheCont>

                </div>
                
                <!-- 最下面的提醒建议 -->
                <tan_needGz_portrait_botAdvise :haveChangeData="allData.breathInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>
              

                
              </div>
            </div>

            <!-- 体动情况 -->
            <div class="needGZ_OneList" v-if="allData.bodyMoveInfoTitleList && allData.bodyMoveInfoTitleList.length > 0">
              <div class="needGZ_OneList_topWrap" @click="tdqk_isExpand = !tdqk_isExpand">
                <div class="needGZ_OneList_top">
                  <img class="report_icon_notice_d" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                  <div class="phenomen">
                    <span :key="index" v-for="(item,index) in allData.bodyMoveInfoTitleList">
                      <span v-if="allData.bodyMoveInfoTitleList == 0">{{ item }}</span>
                      <span v-if="allData.bodyMoveInfoTitleList.length > 0 && index != allData.bodyMoveInfoTitleList.length-1">{{ item }}、</span>
                      <span v-if="allData.bodyMoveInfoTitleList.length > 0 && index == allData.bodyMoveInfoTitleList.length-1">{{ item }}</span>
                    </span>
                  </div>
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!tdqk_isExpand">
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="tdqk_isExpand">
                </div>
                <div class="oListTips" v-if="allData.bodyMoveInfo.deviateTheDay"  v-html="$options.filters.reMate2(allData.bodyMoveInfo.deviateTheDay.descLabel)"></div>
              </div>
              <!-- 弹窗展开内容 -->
              <div class="oneExpandCont" v-show="!allData.bodyMoveInfo.unSecretsDays && tdqk_isExpand">
                <div class="txjyWrap" v-if="allData.bodyMoveInfo.deviateTheDay">
                  <div class="txjyTit">提醒和建议</div>
                  <div class="txjyTit2">{{allData.bodyMoveInfo.deviateTheDay.remindAndSuggestLabel}}</div>
                </div>
                
                <!-- 体动指数分布 -->
                <div class="txjyWrap border_no mt10">
                  <div class="txjyTit txjyTit_after_blue" style="">体动指数分布如下图：</div>
                  <div class="referVal">
                    <div class="referValLeft">
                      <div class="gangKuai2_border"></div>
                      <div class="gantTip">参考范围</div>
                    </div>
                    <div class="referValRight">
                      <div class="gantTip">横轴为体动指数</div>
                    </div>
                  </div>
                  <div id="ech_tdOne" style="height: 150px;"></div>
                  <div class="refer_comTit mt15" v-if=allData.bodyMoveInfo.secretsBodyMoveIndex>{{ allData.bodyMoveInfo.secretsBodyMoveIndex.descLabel }}</div>

                </div>
                <!-- 体动指数分布统计_折线 -->
                <div class="txjyWrap border_no mt10">
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">体动指数每天统计如下：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2"></div>
                        <div class="gantTip">日常表现</div>
                      </div>
                    </div>
                    <div id="ech_td_line" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.bodyMoveInfo.secretsBodyMoveIndexDay">{{ allData.bodyMoveInfo.secretsBodyMoveIndexDay.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.bodyMoveInfo.secretsBodyMoveIndexDayDeviate" :haveChangeData="allData.bodyMoveInfo.secretsBodyMoveIndexDayDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>
                
                <!-- 最下面的提醒建议 -->
                <tan_needGz_portrait_botAdvise :haveChangeData="allData.bodyMoveInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>
                

                
              </div>
            </div>

            <!-- 心跳情况 -->
            <div class="needGZ_OneList" v-if="false && allData.heartInfoTitleList && allData.heartInfoTitleList.length > 0">
              <div class="needGZ_OneList_topWrap" @click="xtqk_isExpand = !xtqk_isExpand">
                <div class="needGZ_OneList_top">
                  <img class="report_icon_notice_d" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                  <div class="phenomen">
                    <span :key="index" v-for="(item,index) in allData.heartInfoTitleList">
                      <span v-if="allData.heartInfoTitleList == 0">{{ item }}</span>
                      <span v-if="allData.heartInfoTitleList.length > 0 && index != allData.heartInfoTitleList.length-1">{{ item }}、</span>
                      <span v-if="allData.heartInfoTitleList.length > 0 && index == allData.heartInfoTitleList.length-1">{{ item }}</span>
                    </span>
                  </div>
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!xtqk_isExpand">
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="xtqk_isExpand">
                </div>
                <div class="oListTips" v-if="allData.heartInfo.deviateTheDay"  v-html="$options.filters.reMate2(allData.heartInfo.deviateTheDay.descLabel)"></div>
              </div>
              <!-- 弹窗展开内容 -->
              <div class="oneExpandCont" v-show="!allData.heartInfo.unSecretsDays && xtqk_isExpand">
                <div class="txjyWrap" v-if="allData.heartInfo.deviateTheDay">
                  <div class="txjyTit">提醒和建议</div>
                  <div class="txjyTit2">{{allData.heartInfo.deviateTheDay.remindAndSuggestLabel}}</div>
                </div>
                <!-- 心率分布 -->
                <div class="txjyWrap border_no mt10">
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">心率分布如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为心率(次/分)</div>
                      </div>
                    </div>
                    <div id="ech_heartOne" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.heartInfo.secretsHeart">{{ allData.heartInfo.secretsHeart.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.heartInfo.secretsHeartDeviate" :haveChangeData="allData.heartInfo.secretsHeartDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>

                <!-- 最下面的提醒建议 -->
                <tan_needGz_portrait_botAdvise :haveChangeData="allData.heartInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>

                
              </div>
            </div>
            
            <!-- 作息规律 -->
            <div class="needGZ_OneList" v-if="allData.dailyRoutineInfoTitleList && allData.dailyRoutineInfoTitleList.length > 0">
              <div class="needGZ_OneList_topWrap" @click="zxgl_isExpand = !zxgl_isExpand">
                <div class="needGZ_OneList_top">
                  <img class="report_icon_notice_d" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                  <div class="phenomen">
                    <span :key="index" v-for="(item,index) in allData.dailyRoutineInfoTitleList">
                      <span v-if="allData.dailyRoutineInfoTitleList == 0">{{ item }}</span>
                      <span v-if="allData.dailyRoutineInfoTitleList.length > 0 && index != allData.dailyRoutineInfoTitleList.length-1">{{ item }}、</span>
                      <span v-if="allData.dailyRoutineInfoTitleList.length > 0 && index == allData.dailyRoutineInfoTitleList.length-1">{{ item }}</span>
                    </span>
                  </div>
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!zxgl_isExpand">
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="zxgl_isExpand">
                </div>
                <div class="oListTips" v-if="allData.dailyRoutineInfo.deviateTheDay"  v-html="$options.filters.reMate2(allData.dailyRoutineInfo.deviateTheDay.descLabel)"></div>
              </div>
              <!-- 弹窗展开内容 -->
              <div class="oneExpandCont" v-show="!allData.dailyRoutineInfo.unSecretsDays && zxgl_isExpand">
                <div class="txjyWrap" v-if="allData.dailyRoutineInfo.deviateTheDay">
                  <div class="txjyTit">提醒和建议</div>
                  <div class="txjyTit2">{{allData.dailyRoutineInfo.deviateTheDay.remindAndSuggestLabel}}</div>
                </div>
                <!-- 上床入睡醒来起床 -->
                <div class="txjyWrap border_no mt10">
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">您上床、入睡、醒来、起床时间点分布如下图：</div>
                    <!-- <div class="lcscSinWrap">
                      <div class="name">离床时长（分钟）</div>
                      <img class="boxBg mt5" src="../../../assets/report_pic_color_d@2x.png" alt="">
                      <div class="boxBgData">
                        <div class="bNum" :key="index" v-for="(item,index) in 11">{{index}}</div>
                      </div>
                    </div> -->
                    <div class="referVal referValTimeSingle">
                      <div class="referValLeft">
                        <div class="gantTip">19:30</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">08:30</div>
                      </div>
                    </div>
                    <div id="id_echSanDian_wrap" style="height: 300px;overflow: auto;" v-if="allData && allData.dailyRoutineInfo && allData.dailyRoutineInfo.secretsDailyRoutine">
                      <div id="echSanDian" :style="{height:allData.dailyRoutineInfo.secretsDailyRoutine.data.length*42 + 'px'}"></div>
                    </div>

                    <!-- 作息规律显示这个 -->
                    <div v-if="allData.dailyRoutineInfo.secretsDailyRoutine">
                      <div class="zxSanWrap mt10">
                        <div class="zxSanList">上床</div>
                        <div class="zxSanList">入睡</div>
                        <div class="zxSanList">醒来</div>
                        <div class="zxSanList">起床</div>
                      </div>
                      <div class="zxSanBotCont mt20">
                        <div class="zxSanBotListWrap mb10" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.isShow_highFreTime2">
                          <div class="zxSanBotList">
                            <div class="flex_Cen_Cen pt15">
                              <div class="zxBoxBlock"></div>
                              <div class="zxBoxName ml5">上床时间高频范围</div>
                            </div>
                            <div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedEd }}</div>
                            <div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedSt">暂无</div>
                          </div>
                          <div class="zxSanBotList">
                            <div class="flex_Cen_Cen pt15">
                              <div class="zxBoxBlock bgFFEAD4"></div>
                              <div class="zxBoxName ml5">入睡时间高频范围</div>
                            </div>
                            <div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStEd }}</div>
                            <div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStSt">暂无</div>
                          </div>
                          <div class="zxSanBotList">
                            <div class="flex_Cen_Cen pt15">
                              <div class="zxBoxBlock bgC6F3E9"></div>
                              <div class="zxBoxName ml5">醒来时间高频范围</div>
                            </div>
                            <div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdEd }}</div>
                            <div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdSt">暂无</div>
                          </div>
                          <div class="zxSanBotList">
                            <div class="flex_Cen_Cen pt15">
                              <div class="zxBoxBlock bgB9DDFF"></div>
                              <div class="zxBoxName ml5">起床时间高频范围</div>
                            </div>
                            <div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedEd }}</div>
                            <div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedSt">暂无</div>
                          </div>
                        </div>
                        <div class='' v-if="allData.dailyRoutineInfo.secretsDailyRoutine">{{ allData.dailyRoutineInfo.secretsDailyRoutine.descLabel }}</div>
                      </div>
                    </div>

                    <!-- 夜间离床显示这个 -->
                    <!-- <div>
                      <div class="lcTimeTip mt10">
                        <div class="lcTimeKuang"></div>
                        <div class="lcTimeFont ml5">离床时间高频范围</div>
                      </div>
                      <div class="refer_comTit mt15" style="height: 66px;line-height: 22px;">
                        <div>·通常会在01:12～02:13，05:18～05:58离床；·</div>
                        <div class="flex">
                          <div>·</div>
                          <div class="colorFF7186">01:12～02:13</div>
                          <div>这个时间段发生的离床是值得注意的。·</div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
                <!-- 入睡时长分布、统计如下图 -->
                <div class="txjyWrap border_no mt10">
                  <!-- 入睡时长分布 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">入睡时长分布如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为入睡时长(分钟)</div>
                      </div>
                    </div>
                    <div id="ech_sleepOne" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsSleep">{{ allData.dailyRoutineInfo.secretsSleep.descLabel }}</div>
                  </div>
                  <!-- 入睡时长统计 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue mt15" style="">入睡时长每天统计如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2"></div>
                        <div class="gantTip">日常表现</div>
                      </div>
                    </div>
                    <div id="ech_sleepTwo" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsSleepDay">{{ allData.dailyRoutineInfo.secretsSleepDay.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.dailyRoutineInfo.secretsSleepDayDeviate" :haveChangeData="allData.dailyRoutineInfo.secretsSleepDayDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>
                <!-- 起床时长分布、统计如下图 -->
                <div class="txjyWrap border_no mt10">
                  <!-- 起床时长分布 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">起床时长分布如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为起床时长(分钟)</div>
                      </div>
                    </div>
                    <div id="ech_getUpOne" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsBed">{{ allData.dailyRoutineInfo.secretsBed.descLabel }}</div>
                  </div>
                  <!-- 起床时长统计 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue mt15" style="">起床时长每天统计如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2"></div>
                        <div class="gantTip">日常表现</div>
                      </div>
                    </div>
                    <div id="ech_getUpTwo" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsBed">{{ allData.dailyRoutineInfo.secretsBedDay.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.dailyRoutineInfo.secretsBedDayDeviate" :haveChangeData="allData.dailyRoutineInfo.secretsBedDayDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>
                
                <!-- 最下面的提醒建议 -->
                <tan_needGz_portrait_botAdvise :haveChangeData="allData.dailyRoutineInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>

                
              </div>
            </div>

            <!-- 夜间离床 -->
            <div class="needGZ_OneList" v-if="allData.leaveBedInfoTitleList && allData.leaveBedInfoTitleList.length > 0">
              <div class="needGZ_OneList_topWrap" @click="yjlc_isExpand = !yjlc_isExpand">
                <div class="needGZ_OneList_top">
                  <img class="report_icon_notice_d" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                  <div class="phenomen">
                    <span :key="index" v-for="(item,index) in allData.leaveBedInfoTitleList">
                      <span v-if="allData.leaveBedInfoTitleList == 0">{{ item }}</span>
                      <span v-if="allData.leaveBedInfoTitleList.length > 0 && index != allData.leaveBedInfoTitleList.length-1">{{ item }}、</span>
                      <span v-if="allData.leaveBedInfoTitleList.length > 0 && index == allData.leaveBedInfoTitleList.length-1">{{ item }}</span>
                    </span>
                  </div>
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!yjlc_isExpand">
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="yjlc_isExpand">
                </div>
                <div class="oListTips" v-if="allData.leaveBedInfo.deviateTheDay"  v-html="$options.filters.reMate2(allData.leaveBedInfo.deviateTheDay.descLabel)"></div>
              </div>
              <!-- 弹窗展开内容 -->
              <div class="oneExpandCont" v-show="!allData.leaveBedInfo.unSecretsDays && yjlc_isExpand">
                <div class="txjyWrap" v-if="allData.leaveBedInfo.deviateTheDay">
                  <div class="txjyTit">提醒和建议</div>
                  <div class="txjyTit2">{{allData.leaveBedInfo.deviateTheDay.remindAndSuggestLabel}}</div>
                </div>
                <!-- 离床次数分布、统计如下图 -->
                <div class="txjyWrap border_no mt10">
                  <!-- 离床次数分布 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">离床次数分布如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为离床次数(分钟)</div>
                      </div>
                    </div>
                    <div id="ech_outBedNumOne" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedTimes">{{ allData.leaveBedInfo.secretsLeaveBedTimes.descLabel }}</div>
                  </div>
                  <!-- 离床次数统计 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue mt15" style="">离床次数每天统计如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2"></div>
                        <div class="gantTip">日常表现</div>
                      </div>
                    </div>
                    <div id="ech_outBedNumTwo" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedTimesDay">{{ allData.leaveBedInfo.secretsLeaveBedTimesDay.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.leaveBedInfo.secretsLeaveBedTimesDayDeviate" :haveChangeData="allData.leaveBedInfo.secretsLeaveBedTimesDayDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>

                <!-- 离床时长分布、统计如下图 -->
                <div class="txjyWrap border_no mt10" v-if="allData.leaveBedInfo.secretsLeaveBedDuration">
                  <!-- 离床时长分布 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">离床时长分布如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为离床时长(分钟)</div>
                      </div>
                    </div>
                    <div id="ech_outBedTimeOne" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedDuration">{{ allData.leaveBedInfo.secretsLeaveBedDuration.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.leaveBedInfo.secretsLeaveBedDurationDeviate" :datatype="'lcscfb'" :haveChangeData="allData.leaveBedInfo.secretsLeaveBedDurationDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>
                <!-- 上床入睡醒来起床 -->
                <div class="txjyWrap border_no mt10" v-if="allData.leaveBedInfo.secretsLeaveBedTimeDuration">
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">每次离床发生的时间点和时长如下图</div>
                    <div class="lcscSinWrap mt10">
                      <div class="name">离床时长（分钟）</div>
                      <img class="boxBg mt5" src="../../../assets/report_pic_color_d@2x.png" alt="">
                      <div class="boxBgData" v-if="allData.leaveBedInfo.secretsLeaveBedTimeDuration">
                        <div class="bNum" :key="index" v-for="(item,index) in allData.leaveBedInfo.secretsLeaveBedTimeDuration.referenceList">
                          <div v-if="item < 90">{{item}}</div>
                          <div v-if="item >= 90">≥{{item}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="referVal referValTimeSingle">
                      <div class="referValLeft">
                        <div class="gantTip">19:30</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">08:30</div>
                      </div>
                    </div>
                    
                    <div id="id_echSanDian_nightOutBed" style="height: 300px;overflow: auto;" v-if="allData && allData.leaveBedInfo && allData.leaveBedInfo.secretsLeaveBedTimeDuration">
                      <div id="echSanDian_nightOutBed" :style="{height:allData.leaveBedInfo.secretsLeaveBedTimeDuration.data.length*42 + 'px'}"></div>
                    </div>
                    

                    <!-- 夜间离床显示这个 -->
                    <div>
                      <div class="lcTimeTip mt10">
                        <div class="lcTimeKuang"></div>
                        <div class="lcTimeFont ml5">离床时间高频范围</div>
                      </div>
                      <div class="refer_comTit mt15" style="line-height: 22px;">
                        <div v-if="allData.leaveBedInfo.secretsLeaveBedTimeDuration" v-html="$options.filters.reMate(allData.leaveBedInfo.secretsLeaveBedTimeDuration.descLabel)"></div>
                        <!-- <div>·通常会在01:12～02:13，05:18～05:58离床；·</div>
                        <div class="flex">
                          <div>·</div>
                          <div class="colorFF7186">01:12～02:13</div>
                          <div>这个时间段发生的离床是值得注意的。·</div>
                        </div> -->
                      </div>
                    </div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.leaveBedInfo.secretsLeaveBedTimeDurationDeviate" :datatype="'lcSdt'" :haveChangeData="allData.leaveBedInfo.secretsLeaveBedTimeDurationDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>

                <!-- 最下面的提醒建议 -->
                <tan_needGz_portrait_botAdvise :haveChangeData="allData.leaveBedInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>

                
              </div>
            </div>
            
            <!-- 睡眠情况 -->
            <div class="needGZ_OneList" v-if="allData.sleepInfoTitleList && allData.sleepInfoTitleList.length > 0">
              <div class="needGZ_OneList_topWrap" @click="smqk_isExpand = !smqk_isExpand">
                <div class="needGZ_OneList_top">
                  <img class="report_icon_notice_d" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                  <div class="phenomen">
                    <span :key="index" v-for="(item,index) in allData.sleepInfoTitleList">
                      <span v-if="allData.sleepInfoTitleList == 0">{{ item }}</span>
                      <span v-if="allData.sleepInfoTitleList.length > 0 && index != allData.sleepInfoTitleList.length-1">{{ item }}、</span>
                      <span v-if="allData.sleepInfoTitleList.length > 0 && index == allData.sleepInfoTitleList.length-1">{{ item }}</span>
                    </span>
                  </div>
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!smqk_isExpand">
                  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="smqk_isExpand">
                </div>
                <div class="oListTips" v-if="allData.sleepInfo.deviateTheDay"  v-html="$options.filters.reMate2(allData.sleepInfo.deviateTheDay.descLabel)"></div>
              </div>
              <!-- 弹窗展开内容 -->
              <div class="oneExpandCont" v-show="!allData.sleepInfo.unSecretsDays && smqk_isExpand">
                <div class="txjyWrap" v-if="allData.sleepInfo.deviateTheDay">
                  <div class="txjyTit">提醒和建议</div>
                  <div class="txjyTit2">{{allData.sleepInfo.deviateTheDay.remindAndSuggestLabel}}</div>
                </div>
                
                <!-- 睡眠时长分布、统计 -->
                <div class="txjyWrap border_no mt10">
                  <!-- 睡眠时长分布 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">睡眠时长分布如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为睡眠时长(小时)</div>
                      </div>
                    </div>
                    <div id="ech_sleepTimeOne" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepDuration">{{ allData.sleepInfo.secretsSleepDuration.descLabel }}</div>
                  </div>
                  <!-- 睡眠时长统计 -->
                  <div>
                    <div class="refer_comLine_heng"></div>
                    <div class="txjyTit txjyTit_after_blue mt15" style="">每天的睡眠时长统计如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2"></div>
                        <div class="gantTip">日常表现</div>
                      </div>
                    </div>
                    <div id="ech_sleepTimeTwo" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepDurationDay">{{ allData.sleepInfo.secretsSleepDurationDay.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.sleepInfo.secretsSleepDurationDayDeviate" :haveChangeData="allData.sleepInfo.secretsSleepDurationDayDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>

                <!-- 睡眠效率分布、统计 -->
                <div class="txjyWrap border_no mt10">
                  <!-- 睡眠效率分布 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">睡眠效率分布如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为睡眠时长(小时)</div>
                      </div>
                    </div>
                    <div id="ech_sleepEffOne" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepEfficiency">{{ allData.sleepInfo.secretsSleepEfficiency.descLabel }}</div>
                  </div>
                  <!-- 睡眠效率统计 -->
                  <div>
                    <div class="refer_comLine_heng"></div>
                    <div class="txjyTit txjyTit_after_blue mt15" style="">每天的睡眠效率统计如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2"></div>
                        <div class="gantTip">日常表现</div>
                      </div>
                    </div>
                    <div id="ech_sleepEffTwo" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepEfficiencyDay">{{ allData.sleepInfo.secretsSleepEfficiencyDay.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.sleepInfo.secretsSleepEfficiencyDayDeviate" :haveChangeData="allData.sleepInfo.secretsSleepEfficiencyDayDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>


                <!-- 睡眠破碎统计_折线 -->
                <div class="txjyWrap border_no mt10">
                  <!--  -->
                  <!-- 睡眠破碎分布 -->
                  <div>
                    <div class="txjyTit txjyTit_after_blue" style="">睡眠效率分布如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为睡眠破碎指标</div>
                      </div>
                    </div>
                    <div id="ech_sleepRrush" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepCrush">{{ allData.sleepInfo.secretsSleepCrush.descLabel }}</div>
                  </div>

                  <!-- 睡眠破碎统计_折线 -->
                  <div class="">
                    <div class="refer_comLine_heng"></div>
                    <div class="txjyTit txjyTit_after_blue mt15" style="">每天的睡眠破碎指标统计如下图：</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2"></div>
                        <div class="gantTip">日常表现</div>
                      </div>
                    </div>
                    <div id="ech_sleepRrush_line" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepCrushDay">{{  allData.sleepInfo.secretsSleepCrushDay.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.sleepInfo.secretsSleepCrushDayDeviate" :haveChangeData="allData.sleepInfo.secretsSleepCrushDayDeviate"></tan_needGz_portrait_botZheCont>
                  </div>
                </div>
                
                <!-- 最下面的提醒建议 -->
                <tan_needGz_portrait_botAdvise :haveChangeData="allData.sleepInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>

                
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';
import tan_needGz_portrait_isHaveChange from './tan_needGz_portrait_isHaveChange.vue';     //昨晚是否有值得关注的变化
import tan_needGz_portrait_botZheCont from './tan_needGz_portrait_botZheCont.vue';         //是否发生偏离
import tan_needGz_portrait_botAdvise from './tan_needGz_portrait_botAdvise.vue';           //最下面的提醒建议

export default {
  components: { tan_needGz_portrait_isHaveChange,tan_needGz_portrait_botZheCont,tan_needGz_portrait_botAdvise },
  filters: {
    reMate(val){
      return CustomRichText.reMate(portFn.function_reg_str_to_arr(val))
    },
    reMate2(val){
      return CustomRichText.reMate2(portFn.function_reg_str_to_arr(val))
    },
    dataChange(val){
      let newVal = val.slice(5,7) + '月' + val.slice(8,10) + '日'
      return newVal
    },
  },
  props: {
    
  },
  watch: {
    
  },
  data() {
    return {
      innerHeight: null,
      aaaa: '2033-06-29',
      bedId: '',
      tan_needGZ_single: false,
      hxqk_isExpand: true,     // 呼吸情况是否展开
      tdqk_isExpand: true,     // 体动情况是否展开
      xtqk_isExpand: true,     // 心跳情况是否展开
      zxgl_isExpand: true,     // 作息规律是否展开
      yjlc_isExpand: true,     // 夜间离床是否展开
      smqk_isExpand: true,     // 睡眠情况是否展开


      allData: null,
      topDateList: null,      
      top_date_selval: '',
      




      // 日历相关
      showCalendar: false,
      activeDates: [],
      activeDate: '',
      activeType: 1, // 默认今天
      invalidDates: [],
      // effeDates: [],
      effeDates: ['2023-06-05', '2023-06-07', '2023-06-08', '2023-06-09', '2023-06-10', '2023-06-11', '2023-06-12', '2023-06-13', '2023-06-14', '2023-06-15', '2023-06-16', '2023-06-17', '2023-06-18', '2023-06-19'],
    };
  },
  created() {},
  mounted() {
    // this.getActiveDates()
    // this.activeDate = this.activeDates[0];
    
    
  },
  methods: {
    // 外界调用这个组件
    openComponent(data){
      console.log('浏览器窗口可见部分高度' + window.innerHeight)
      this.innerHeight = Number(window.innerHeight) - 66
      console.log('调用了单人详情')
      console.log(data)
      this.bedId = data.bedId;
      this.tan_needGZ_single = true;
      this.nowType = data.nowType
      if(data.nowType == 1){
        this.getNeedFollowByBedId();              //需关注老人单日详情_单日需关注的变化
      }else if(data.nowType == 7){
        this.getNeedFollowDateListByBedId();      //需关注老人七日详情_获取多日需关注老人日期列表
      }

    },
    // 需关注老人单日详情_单日需关注的变化
    getNeedFollowByBedId(){
      this.hxqk_isExpand = true
      this.tdqk_isExpand = true
      this.xtqk_isExpand = true
      this.zxgl_isExpand = true
      this.yjlc_isExpand = true
      this.smqk_isExpand = true
      
      let obj = {
        bedId: this.bedId
      }
      if(this.nowType == 7){
        obj.date = this.top_date_selval
      }
      this.$get(
        'api/v4/home/getNeedFollowByBedId',
        // 'api/v4/home/getDigitalPortraitBySnBedId',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log(res.data)
              this.allData = res.data;

              this.$nextTick((resNext) => {
                // 呼吸情况
                if(res.data.breathInfo){
                  if(!res.data.breathInfo.unSecretsDays){
                    // 呼吸率分布图
                    let hxl_dis = {
                      name: '呼吸率',
                      xAxis: {
                        data: this.allData.breathInfo.secretsBreath.xaxis
                      },
                      series: {
                        data: this.allData.breathInfo.secretsBreath.data,
                        range: this.allData.breathInfo.secretsBreath.range
                      },
                    }
                    // 吸呼比分布图
                    let xhb_dis = {
                      name: '吸呼比',
                      xAxis: {
                        data: this.allData.breathInfo.secretsInExRatio.xaxis
                      },
                      series: {
                        data: this.allData.breathInfo.secretsInExRatio.data,
                        range: this.allData.breathInfo.secretsInExRatio.range
                      },
                    }
                    this.getMyChart_optionBar('ech_breathOne','hxl_dis',hxl_dis)          //呼吸率分布
                    this.getMyChart_optionBar('ech_breathTwo','xhb_dis',xhb_dis)         //吸呼比分布
                  }
                }
                // 体动情况
                if(res.data.bodyMoveInfo){
                  if(!res.data.bodyMoveInfo.unSecretsDays){
                    // 体动分布图
                    let td_dis = {
                      name: '体动指数',
                      xAxis: {
                        data: this.allData.bodyMoveInfo.secretsBodyMoveIndex.xaxis
                      },
                      series: {
                        data: this.allData.bodyMoveInfo.secretsBodyMoveIndex.data,
                        range: this.allData.bodyMoveInfo.secretsBodyMoveIndex.range
                      },
                    }
                    // 体动破碎图
                    let td_crush_line = {
                      xAxis: {
                        data: this.allData.bodyMoveInfo.secretsBodyMoveIndexDay.xaxis
                      },
                      series: {
                        data: this.allData.bodyMoveInfo.secretsBodyMoveIndexDay.data,
                        range: this.allData.bodyMoveInfo.secretsBodyMoveIndexDay.range
                      },
                      avg: 10
                    }
                    this.getMyChart_optionBar('ech_tdOne','td_dis',td_dis)                //体动指数分布
                    this.getMyChart_optionLine('ech_td_line','td_crush_line',td_crush_line)    //体动指数统计_折线
                  }
                }
                // 心跳情况
                if(res.data.heartInfo){
                  if(!res.data.heartInfo.unSecretsDays){
                    // 心率分布图
                    let heart_dis = {
                      name: '心率',
                      xAxis: {
                        data: this.allData.heartInfo.secretsHeart.xaxis
                      },
                      series: {
                        data: this.allData.heartInfo.secretsHeart.data,
                        range: this.allData.heartInfo.secretsHeart.range
                      },
                    }
                    this.getMyChart_optionBar('ech_heartOne','heart_dis',heart_dis)             //心跳分布
                  }
                }
                // 作息规律
                if(res.data.dailyRoutineInfo){
                    
                  if(!res.data.dailyRoutineInfo.unSecretsDays){

                    // 作息规律_上床入睡醒来起床散点图secretsDailyRoutine  未写
                    let zxglArr = this.allData.dailyRoutineInfo.secretsDailyRoutine.data;
                    let zxgl_highFreTime = this.allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime;
                    let zxgl_scRsXlQc_sandian = {
                      xAxis_data: this.function_get_all_mintues(),
                      yAxis_data: [],
                      series_data0: [],
                      series_data1: [],
                      series_data2: [],
                      series_data3: [],
                      scatter_interval1: [],
                      scatter_interval2: [],
                      scatter_interval3: [],
                      scatter_interval4: [],
                    }
                    for(let i = 0;i < zxglArr.length;i++){
                      // console.log(zxglArr[i])
                      zxgl_scRsXlQc_sandian.yAxis_data.push(zxglArr[i].date)
                      // zxgl_scRsXlQc_sandian.series_data0.push(zxglArr[i].getBed)
                      zxgl_scRsXlQc_sandian.series_data0.push([zxglArr[i].getBed,zxglArr[i].date])
                      zxgl_scRsXlQc_sandian.series_data1.push([zxglArr[i].sleepSt,zxglArr[i].date])
                      zxgl_scRsXlQc_sandian.series_data2.push([zxglArr[i].sleepEd,zxglArr[i].date])
                      zxgl_scRsXlQc_sandian.series_data3.push([zxglArr[i].leaveBed,zxglArr[i].date])
                    }
                    // 上床
                    if(zxgl_highFreTime.getBedSt){
                      zxgl_scRsXlQc_sandian.scatter_interval1 = [[{'xAxis': zxgl_highFreTime.getBedSt},{'xAxis': zxgl_highFreTime.getBedEd}]]
                    }
                    // 入睡
                    if(zxgl_highFreTime.sleepStSt){
                      zxgl_scRsXlQc_sandian.scatter_interval2 = [[{'xAxis': zxgl_highFreTime.sleepStSt},{'xAxis': zxgl_highFreTime.sleepStEd}]]
                    }
                    // 醒来
                    if(zxgl_highFreTime.sleepEdSt){
                      zxgl_scRsXlQc_sandian.scatter_interval3 = [[{'xAxis': zxgl_highFreTime.sleepEdSt},{'xAxis': zxgl_highFreTime.sleepEdEd}]]
                    }
                    // 起床
                    if(zxgl_highFreTime.leaveBedSt){
                      zxgl_scRsXlQc_sandian.scatter_interval4 = [[{'xAxis': zxgl_highFreTime.leaveBedSt},{'xAxis': zxgl_highFreTime.leaveBedEd}]]
                    }
                    // 前端自己增加是否显示作息规律中四个高频内容
                    if(zxgl_highFreTime.getBedSt && zxgl_highFreTime.sleepStSt && zxgl_highFreTime.sleepEdSt && zxgl_highFreTime.leaveBedSt){
                      this.allData.dailyRoutineInfo.secretsDailyRoutine.isShow_highFreTime2 = true
                    }else{
                      this.allData.dailyRoutineInfo.secretsDailyRoutine.isShow_highFreTime2 = false
                    }
                    // 作息规律_入睡时长分布图
                    let zxgl_rssc_dis = {
                      name: '入睡时长',
                      xAxis: {
                        data: this.allData.dailyRoutineInfo.secretsSleep.xaxis
                      },
                      series: {
                        data: this.allData.dailyRoutineInfo.secretsSleep.data,
                        range: this.allData.dailyRoutineInfo.secretsSleep.range
                      },
                    }
                    // 作息规律_入睡时长统计图
                    let zxgl_rssc_dis2 = {
                      xAxis: {
                        // data: [0,1,2,3]
                        data: this.allData.dailyRoutineInfo.secretsSleepDay.xaxis
                      },
                      series: {
                        data: this.allData.dailyRoutineInfo.secretsSleepDay.data,
                        range: this.allData.dailyRoutineInfo.secretsSleepDay.range
                        // data: [10,14,'3','32'],
                        // range: [1,2]
                      },
                    }
                    // 作息规律_起床时长分布图
                    let zxgl_qcsc_dis = {
                      name: '起床时长',
                      xAxis: {
                        data: this.allData.dailyRoutineInfo.secretsBed.xaxis
                      },
                      series: {
                        data: this.allData.dailyRoutineInfo.secretsBed.data,
                        range: this.allData.dailyRoutineInfo.secretsBed.range
                      },
                    }
                    // 作息规律_起床时长统计图
                    let zxgl_qcsc_dis2 = {
                      xAxis: {
                        data: this.allData.dailyRoutineInfo.secretsBedDay.xaxis
                      },
                      series: {
                        data: this.allData.dailyRoutineInfo.secretsBedDay.data,
                        range: this.allData.dailyRoutineInfo.secretsBedDay.range
                      },
                    }
                    // id为echSanDian的dom滚动到底部
                    let message = document.getElementById('id_echSanDian_wrap');
                    message.scrollTop = message.scrollHeight;

                    this.getMyChart_optionSca('echSanDian','zxgl_scRsXlQc_sandian',zxgl_scRsXlQc_sandian)         // 作息规律_上床入睡醒来起床散点图secretsDailyRoutine
                    this.getMyChart_optionBar('ech_sleepOne','zxgl_rssc_dis',zxgl_rssc_dis)             //入睡时长分布
                    this.getMyChart_optionBar('ech_sleepTwo','zxgl_rssc_dis2',zxgl_rssc_dis2)            //入睡时长统计
                    this.getMyChart_optionBar('ech_getUpOne','zxgl_qcsc_dis',zxgl_qcsc_dis)             //起床时长分布
                    this.getMyChart_optionBar('ech_getUpTwo','zxgl_qcsc_dis2',zxgl_qcsc_dis2)            //起床时长统计
                  }
                }
                
                

                // 夜间离床
                if(res.data.leaveBedInfo){
                  if(!res.data.leaveBedInfo.unSecretsDays){
                    // 夜间离床_离床次数分布图
                    let yjlc_lccs_dis = {
                      name: '离床次数',
                      xAxis: {
                        data: this.allData.leaveBedInfo.secretsLeaveBedTimes.xaxis
                      },
                      series: {
                        data: this.allData.leaveBedInfo.secretsLeaveBedTimes.data,
                        range: this.allData.leaveBedInfo.secretsLeaveBedTimes.range
                      },
                    }
                    // 夜间离床_离床次数统计图
                    let yjlc_lccs_dis2 = {
                      xAxis: {
                        data: this.allData.leaveBedInfo.secretsLeaveBedTimesDay.xaxis
                      },
                      series: {
                        data: this.allData.leaveBedInfo.secretsLeaveBedTimesDay.data,
                        range: this.allData.leaveBedInfo.secretsLeaveBedTimesDay.range
                      },
                    }
                    // 夜间离床_离床时长分布图
                    if(this.allData.leaveBedInfo.secretsLeaveBedDuration){
                      let yjlc_lcsc_dis = {
                        name: '离床时长',
                        xAxis: {
                          data: this.allData.leaveBedInfo.secretsLeaveBedDuration.xaxis
                        },
                        series: {
                          data: this.allData.leaveBedInfo.secretsLeaveBedDuration.data,
                          range: this.allData.leaveBedInfo.secretsLeaveBedDuration.range
                        },
                      }
                      this.getMyChart_optionBar('ech_outBedTimeOne','yjlc_lcsc_dis',yjlc_lcsc_dis)        //离床时长分布
                    }
                    // 夜间离床_上床入睡醒来起床散点图secretsDailyRoutine 
                    if(this.allData.leaveBedInfo.secretsLeaveBedTimeDuration){

                      let yjlcArr = this.allData.leaveBedInfo.secretsLeaveBedTimeDuration.data
                      let sc_rs_xl_qcData = {
                        xAxis_data: this.function_get_all_mintues(),
                        yAxis_data: [],
                        series_data: [],
                        scatter_interval: []
                      }
                      for(let i = 0;i < yjlcArr.length;i++){
                        sc_rs_xl_qcData.yAxis_data.push(yjlcArr[i].date)
                        if(yjlcArr[i].timeDuration){
                          for(let j = 0;j < yjlcArr[i].timeDuration.length;j++){
                            let aaa = [
                              yjlcArr[i].timeDuration[j].timeSt,
                              yjlcArr[i].date,
                              yjlcArr[i].timeDuration[j].duration
                            ]
                            sc_rs_xl_qcData.series_data.push(aaa)
                          }
                          
                        }
                      }
                      let yjlc_highFreTime = this.allData.leaveBedInfo.secretsLeaveBedTimeDuration.highFreTime;
                      if(yjlc_highFreTime){
                        for(let i = 0;i < yjlc_highFreTime.length;i++){
                          let aaa = [
                            {'xAxis': yjlc_highFreTime[i].timeSt},
                            {'xAxis': yjlc_highFreTime[i].timeEd}
                          ]
                          sc_rs_xl_qcData.scatter_interval.push(aaa)
                        }
                      }

                      // id为id_echSanDian_nightOutBed的dom滚动到底部
                      let message_OutBed = document.getElementById('id_echSanDian_nightOutBed');
                      message_OutBed.scrollTop = message_OutBed.scrollHeight;
                      this.getMyChart_optionSca2('echSanDian_nightOutBed','sc_rs_xl_qcData',sc_rs_xl_qcData)   //夜间离床散点


                    }

                    this.getMyChart_optionBar('ech_outBedNumOne','yjlc_lccs_dis',yjlc_lccs_dis)         //离床次数分布
                    this.getMyChart_optionBar('ech_outBedNumTwo','yjlc_lccs_dis2',yjlc_lccs_dis2)        //离床次数统计
                  }
                }

                // 睡眠情况
                if(res.data.sleepInfo){
                  if(!res.data.sleepInfo.unSecretsDays){
                    // 睡眠情况_睡眠时长分布图
                    let smqk_smsc_dis = {
                      name: '睡眠时长',
                      xAxis: {
                        data: this.allData.sleepInfo.secretsSleepDuration.xaxis
                      },
                      series: {
                        data: this.allData.sleepInfo.secretsSleepDuration.data,
                        range: this.allData.sleepInfo.secretsSleepDuration.range
                      },
                    }
                    // 睡眠情况_睡眠时长统计图
                    let smqk_smsc_dis2 = {
                      xAxis: {
                        data: this.allData.sleepInfo.secretsSleepDurationDay.xaxis
                      },
                      series: {
                        data: this.allData.sleepInfo.secretsSleepDurationDay.data,
                        range: this.allData.sleepInfo.secretsSleepDurationDay.range
                      },
                    }
                    // 睡眠情况_睡眠效率分布图
                    let smqk_smxl_dis = {
                      name: '睡眠效率',
                      xAxis: {
                        data: this.allData.sleepInfo.secretsSleepEfficiency.xaxis
                      },
                      series: {
                        data: this.allData.sleepInfo.secretsSleepEfficiency.data,
                        range: this.allData.sleepInfo.secretsSleepEfficiency.range
                      },
                    }
                    // 睡眠情况_睡眠效率统计图
                    let smqk_smxl_dis2 = {
                      xAxis: {
                        data: this.allData.sleepInfo.secretsSleepEfficiencyDay.xaxis
                      },
                      series: {
                        data: this.allData.sleepInfo.secretsSleepEfficiencyDay.data,
                        range: this.allData.sleepInfo.secretsSleepEfficiencyDay.range
                      },
                    }
                    // 睡眠情况_睡眠破碎分布图
                    let smqk_smps_dis = {
                      name: '睡眠破碎',
                      xAxis: {
                        data: this.allData.sleepInfo.secretsSleepCrush.xaxis
                      },
                      series: {
                        data: this.allData.sleepInfo.secretsSleepCrush.data,
                        range: this.allData.sleepInfo.secretsSleepCrush.range
                      },
                    }
                    // 睡眠情况_睡眠破碎统计图
                    let smqk_smps_dis2 = {
                      xAxis: {
                        data: this.allData.sleepInfo.secretsSleepCrushDay.xaxis,
                      },
                      series: {
                        data: this.allData.sleepInfo.secretsSleepCrushDay.data,
                        range: this.allData.sleepInfo.secretsSleepCrushDay.range
                      },
                      // avg: res.data.median
                      avg: 10
                    };
                    this.getMyChart_optionBar('ech_sleepTimeOne','smqk_smsc_dis',smqk_smsc_dis)         //睡眠时长分布
                    this.getMyChart_optionBar('ech_sleepTimeTwo','smqk_smsc_dis2',smqk_smsc_dis2)        //睡眠时长统计
                    this.getMyChart_optionBar('ech_sleepEffOne','smqk_smxl_dis',smqk_smxl_dis)          //睡眠效率分布
                    this.getMyChart_optionBar('ech_sleepEffTwo','smqk_smxl_dis2',smqk_smxl_dis2)         //睡眠效率统计
                    this.getMyChart_optionBar('ech_sleepRrush','smqk_smps_dis',smqk_smps_dis)    //睡眠破碎分布
                    this.getMyChart_optionLine('ech_sleepRrush_line','smqk_smps_dis2',smqk_smps_dis2)    //睡眠破碎统计
                  }
                }
              })

              this.$forceUpdate()
              this.$nextTick((res2) => {
                this.hxqk_isExpand = false
                this.tdqk_isExpand = false
                this.xtqk_isExpand = false
                this.zxgl_isExpand = false
                this.yjlc_isExpand = false
                this.smqk_isExpand = false
              })
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    
    },
    // 需关注老人七日详情_获取多日需关注老人日期列表
    getNeedFollowDateListByBedId(){
      let obj = {
        bedId: this.bedId
      }
      this.$get(
        'api/v4/home/getNeedFollowDateListByBedId',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log(res.data)
              this.topDateList = res.data.reverse();
              this.top_date_selval = res.data[0].date;
              this.getNeedFollowByBedId();              //需关注老人单日详情_单日需关注的变化
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    
    },



    
    // 公共柱状图
    getMyChart_optionBar(idName, type, olddata) {
      let data = olddata
      // type  
      // 呼吸率分布hxl_dis  吸呼比分布xhb_dis  
      // 体动指数分布td_dis  
      // 心跳分布heart_dis  
      // 入睡时长分布zxgl_rssc_dis  入睡时长统计zxgl_rssc_dis2
      // 起床时长分布zxgl_qcsc_dis  起床时长统计zxgl_qcsc_dis2
      // 离床次数分布yjlc_lccs_dis  离床次数统计yjlc_lccs_dis2
      // 离床时长分布yjlc_lcsc_dis
      // 睡眠时长分布smqk_smsc_dis  睡眠时长统计smqk_smsc_dis2
      // 睡眠效率分布smqk_smxl_dis  睡眠效率统计smqk_smxl_dis2
      // 睡眠破碎分布smqk_smps_dis

      // type  离床次数lccs  lccs2
      this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
      console.log(idName, type, data)


      // 判断是哪些类型的
      let allType;        //蓝色紫色区域范围都有的1   纯蓝色的2
      if(type == 'hxl_dis' || type == 'xhb_dis' || type == 'td_dis' || type == 'heart_dis' || type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lccs_dis' || type == 'yjlc_lcsc_dis' || type == 'smqk_smsc_dis' || type == 'smqk_smxl_dis' || type == 'smqk_smps_dis'){
        allType = 1
      }else {
        allType = 2
      }
      let x1,x2;

      let xAxis_axisLabel_interval = 0;     //x轴最小间隔
      // 蓝色紫色区域范围都有的1
      if(allType == 1){
        // 百分比处理
        for(let i = 0;i < data.series.data.length;i++){
          data.series.data[i] = Math.round(data.series.data[i] * 100)
        }
        
        // 柱状图bar颜色处理
        if(data.series.range){
          for(let i = 0;i < data.xAxis.data.length;i++){
            // 在范围内
            if(Number(data.xAxis.data[i]) >= Number(data.series.range[0]) && Number(data.xAxis.data[i]) <= Number(data.series.range[1])){
              data.series.data[i] = {
                value: data.series.data[i],
                itemStyle: {color: '#1890FF'}
              }
            }else {
              data.series.data[i] = {
                value: data.series.data[i],
                itemStyle: {color: '#B17DFF'}
              }
            }
          }
        }
        
        // 区间范围计算
        let singleBarAreaWidth = 750 / data.xAxis.data.length;
        let xAxis_data = data.xAxis.data;
        let markArea_range = data.series.range
        if (xAxis_data.indexOf(markArea_range[0]) != -1) {
          x1 = xAxis_data.indexOf(markArea_range[0]) * singleBarAreaWidth + 30;
        }
        if (xAxis_data.indexOf(markArea_range[1]) != -1) {
          x2 = xAxis_data.indexOf(markArea_range[1]) * singleBarAreaWidth + singleBarAreaWidth + 30;
        }
      }else if(allType == 2){
        x1 = 300
        x1 = 500
      }

      if(type == 'smqk_smsc_dis' || type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2' || type == 'yjlc_lccs_dis2' || type == 'smqk_smsc_dis2' || type == 'smqk_smxl_dis2'){
        xAxis_axisLabel_interval = 2
      }


      // 需要分钟转换小时分钟的
      let timeFonts = []
      if(type == 'zxgl_rssc_dis'){      //入睡时长分布
        for(let i = 0;i < data.series.data.length;i++){
          if(data.series.data[i].value){
            timeFonts.push(this.formaTime(data.series.data[i].value))
          }else{
            timeFonts.push('-')
          }
          
        }
      }




      let maxNum = Math.max(...data.series.data)
      // let yAxis_max = Math.round(maxNum / 10) * 10 + 10
      let yAxis_max = null;
      var optionBar = {
        tooltip: {
          // show: false,
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderColor: '#ABD7FF',
          borderWidth: 1,
          spanStyle: {
            color: '#fff',
          },
          confine: true,
          borderRadius: 5,
          formatter: function(params) {
            console.log(type);
            console.log(params);
            
            // 判断除了下面这些类型，剩余类型中params[0].data.value是否为undefined，如果是undefined，不显示浮窗（算法数据多给了一条导致）
            if(!(type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2' || type == 'smqk_smsc_dis2' || type == 'yjlc_lccs_dis2' || type == 'smqk_smxl_dis2')){
              if(typeof params[0].data.value == 'undefined'){
                return;
              }
            }
            if(type == 'xhb_dis' || type == 'td_dis' || type == 'smqk_smps_dis'){      //吸呼比分布  体动指数分布  破碎指标分布
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '</span>'
              );
            } else if(type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lcsc_dis'){   //入睡时长分布  起床时长分布  离床时长分布
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '分钟</span>'
              );
            } else if(type == 'yjlc_lccs_dis'){      //离床次数分布 
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '次</span>'
              );
            } else if(type == 'hxl_dis' || type == 'heart_dis') {            //呼吸率分布  心率分布
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '次/分</span>'
              );
            } else if(type == 'smqk_smxl_dis') {            //睡眠效率分布
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '%</span>'
              );
            } else if(type == 'smqk_smsc_dis') {            //睡眠时长分布
              let hourMin = params[0].axisValue;
              if(hourMin < 60){
                return (
                  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                  params[0].data.value + 
                  `%${data.name}集中`+
                  '<br/>' +
                  '<span style="margin-left:10px;"> 在' + hourMin + '分钟</span>'
                );
              }else {
                let nowTips = ''
                if(hourMin % 60 == 0){
                  nowTips += Math.floor(Number(hourMin) / 60) + '小时'
                }else {
                  nowTips += Math.floor(Number(hourMin) / 60) + '小时' + (hourMin % 60) + '分钟'
                }
                return (
                  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                  params[0].data.value + 
                  `%${data.name}集中`+
                  '<br/>' +
                  '<span style="margin-left:10px;"> 在' + nowTips +'</span>'
                );
              }
            } else if(type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2' || type == 'smqk_smsc_dis2'){          //入睡时长统计  起床时长统计  睡眠时长统计
              let hourMin = params[0].data;
              if (hourMin == '-') {
                console.log('不存在params[0].data.value');
                // return params[0].name + '<br/>' + '入睡时长' + '-' + '分钟';
                return params[0].name + '<br/>' + '' + '-' + '分钟';
              } else {
                console.log('存在params[0].data.value');
                if (hourMin < 60) {
                  return (
                    params[0].name +
                    '<br/>' +
                    `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                    (params[0].data.isEmpty ? '-' : hourMin) +
                    '分钟'
                  );
                } else {
                  let nowTips = ''
                  if(hourMin % 60 == 0){
                    nowTips += Math.floor(Number(hourMin) / 60) + '小时'
                  }else {
                    nowTips += Math.floor(Number(hourMin) / 60) + '小时' + (hourMin % 60) + '分钟'
                  }
                  return (
                    params[0].name +
                    '<br/>' +
                    `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                    nowTips
                  );
                }
              }
            } else if(type == 'yjlc_lccs_dis2'){      //离床次数统计
              return (
                params[0].name +
                '<br/>' +
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data +
                '次'
              );
            } else if(type == 'smqk_smxl_dis2'){      //睡眠效率统计
              return (
                params[0].name +
                '<br/>' +
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data +
                '%'
              );
            } else {
              return (
                params[0].name + 
                '<br/>' +
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data + '分钟'
              );
            }
          },
        },
        grid: {
          left: '0%',
          right: '0.5%',
          top: '10%',
          bottom: '1%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis.data,
            axisLabel: {
              // interval: xAxis_axisLabel_interval,
              // spanStyle: {
              //   color: '', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:'',
              },
              formatter(value,index) {
                if(type == 'smqk_smsc_dis'){     //睡眠时长分布
                  let surplus = value % 60;
                  if (surplus == 0) {
                    return value / 60;
                  }
                  return '';
                } else {
                  return value
                }
              }

            },
            axisLine: {
              lineStyle: {
                color: '#9094A6',
              },
            },
            
            axisTick: {
              show: false,
              // alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            max: yAxis_max,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'solid',
                color: '#E4E6EC'
              }
            },
            minInterval: 10, //设置最小间隔为1，防止出现小数
            axisLabel: {
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:''
              },
              formatter: function (value, index) {
                if(type == 'hxl_dis' || type == 'xhb_dis' || type == 'td_dis' || type == 'heart_dis' || type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lccs_dis' || type == 'yjlc_lcsc_dis' || type == 'smqk_smsc_dis' || type == 'smqk_smxl_dis' || type == 'smqk_smps_dis' || type == 'smqk_smxl_dis2'){
                  return value + '%';
                }else if(type == 'yjlc_lccs_dis2'){     //离床次数统计
                  return value + '次';
                }else {
                  return value + '分';
                }
               
              }
            },
            axisLine: {
              lineStyle: {
                color: '#c7c6c9',
              },
              show: false,
            },
            splitNumber: 3,
          },
        ],
        series: [
          {
            data: data.series.data,
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [4, 4, 0, 0],
                color: '#1890FF'
              },
            },
            markArea: type == 'hxl_dis' || type == 'xhb_dis' || type == 'td_dis' || type == 'heart_dis' || type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lccs_dis' || type == 'yjlc_lcsc_dis' || type == 'smqk_smsc_dis' || type == 'smqk_smxl_dis' || type == 'smqk_smps_dis' ?{
              silent:true,
              data: [
                [
                  { x: x1, },
                  { x: x2, },
                ],
              ],
              itemStyle: {
                borderType: 'dashed',
                borderColor: '#1890FF',
                borderWidth: 1,
                color: 'rgba(24,144,255,0.05)',
              }
            } : {
              silent:true,
              data: [
                [
                  { yAxis: data.series.range[0], },
                  { yAxis: data.series.range[1], },
                ],
              ],
              itemStyle: {
                // borderType: 'dashed',
                // borderColor: '#1890FF',
                // borderWidth: 1,
                color: 'rgba(24,144,255,0.05)',
              }
            },
          }
          
        ]
      }
      this.myChart_Bar.setOption(optionBar,true);
      window.addEventListener('resize', () => {
        this.myChart_Bar.resize();
      });
      this.$forceUpdate()
    },
    // 公共折线图
    getMyChart_optionLine(idName, type, olddata) {
      let data = olddata
      // 体动指数统计_折线td_crush_line  睡眠破碎统计smqk_smps_dis2
      this.myChart_Line = this.$echarts.init(document.getElementById(idName));
      console.log(idName, type, data)

      let maxNum = Math.max(...data.series.data)
      let yAxis_max = Math.round(maxNum / 10) * 10 + 10
      

      let grid_left = '0.5%'
      let grid_bottom = '1%'

      if(type == 'td_crush_line'){             //体动指数统计_折线
        yAxis_max = null
        grid_left = '1%'
      } else if(type == 'smqk_smps_dis2'){    //睡眠破碎统计
        yAxis_max = null
      } 
      var optionLine = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderColor: '#ABD7FF',
          borderWidth: 1,
          spanStyle: {
            color: '#fff',
          },
          confine: true,
          borderRadius: 5,
          formatter: function(params) {
            console.log(type);
            console.log(params);
            // if (type == 'bjbl') {      //报警比例
              return (
                // params[0].name +
                // '<br/>' +
                // '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                // params[0].data + '%'


                params[0].name +
                '<br/>' +
                '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                params[0].data 
              );
            // } 
          },
        },
        grid: {
          left: grid_left,
          // left: '0%',
          right: '0.5%',
          top: '15%',
          bottom: grid_bottom,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis.data,
            axisLabel: {
              // interval: 10,
              // spanStyle: {
              //   color: '', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:'',
              },
              show: type == 'bjbl' ? false : true
            },
            axisLine: {
              lineStyle: {
                color: '#9094A6',
              },
            },
            
            axisTick: {
              show: false,
              // alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            max: yAxis_max,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#CACDD9'
              }
            },
            // minInterval: 1100, //设置最小间隔为1，防止出现小数
            minInterval: 1, //设置最小间隔为1，防止出现小数
            axisLabel: {
              // spanStyle: {
              //   color: '#5E6779', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:''
              }
            },
            axisLine: {
              lineStyle: {
                color: '#c7c6c9',
              },
              show: false,
            },
            splitNumber: 1,
          },
        ],
        series: [
          {
            data: data.series.data,
            type: 'line',
            barWidth: 20,
            // symbol: 'none',
            lineStyle:{           //线条颜色
              color:'#1890FF'
            },
            // smooth: true,         //平滑处理
            symbol: 'circle',
            showSymbol: type == 'bjbl' ? false : true,
            symbolSize: 8,
            color: '#1890FF',
            areaStyle: type == 'seven_bjbl' || type == 'bbbb' ? {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(24, 144, 255, 0.4)', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(24, 144, 255, 0.05)', // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            } : null,
            markLine: type == 'bbbb' ? {
              symbol: 'none',
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
              data: [
                {
                  silent: false, //鼠标悬停事件  true没有，false有
                  lineStyle: {
                    //警戒线的样式  ，虚实  颜色
                    type: 'dashed',
                    color: '#63B2FB',
                  },
                  label: {
                    position: 'end',
                    formatter: '',
                  },
                  yAxis: data.avg, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
              ],
            } : null,
            markArea: {
              silent:true,
              data: [
                [
                  {
                    name: '',
                    yAxis: data.series.range[0],
                    // yAxis: 10,
                    itemStyle: {
                      color: 'rgba(24,144,255,0.05)',
                    },
                  },
                  {
                    yAxis: data.series.range[1],
                    // yAxis: 40,
                  },
                ],
              ]
            } 
          }
          
        ]
      }
      this.myChart_Line.setOption(optionLine,true);
      window.addEventListener('resize', () => {
        this.myChart_Line.resize();
      });
      this.$forceUpdate()
    },

    // 公共散点图_作息规律上床入睡醒来起床
    getMyChart_optionSca(idName, type, olddata){
      let data = olddata
      console.log(idName, type, olddata)
      this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
      let xAxis_data = data.xAxis_data
      let yAxis_data = data.yAxis_data
      let series_data0 = data.series_data0
      let series_data1 = data.series_data1
      let series_data2 = data.series_data2
      let series_data3 = data.series_data3
      let scatter_interval1 = data.scatter_interval1
      let scatter_interval2 = data.scatter_interval2
      let scatter_interval3 = data.scatter_interval3
      let scatter_interval4 = data.scatter_interval4


      let optionBar = {
        tooltip: {
          type: 'none',
          axisPointer: { // 十字
            type: 'cross',
            snap: false,
            animation: true,
            label: {
              color: '#FFFFFF',
              backgroundColor: '#5F64E7',
              opacity: 1
            },
            crossStyle: {
              color: '#BCB6E8',
              width: 1
            }
          },
          backgroundColor: "#FFFFFF",
          borderColor: "#ABD7FF",
          borderWidth: 1,
          borderRadius: 5,
          textStyle: {
            color: "#262626",
          },
          confine: true,
          formatter: function (val) {
            return val.seriesName + '<br/>' + val.marker + val.value[1] + '为' + val.value[0].toString();
          }
        },
        xAxis: [
          {
            position: 'top',
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            data: xAxis_data,
          }
        ],
        yAxis: [
          {
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#A5A9BC',
            },
            axisTick: {
              show: false
            },
            inverse: true, // 反转
            data: yAxis_data,
            splitArea: {
              show: true,
              interval: 'auto',
              areaStyle: {
              }
            }
          }
        ],
        grid: {
          x: 12,
          y: -1,
          x2: 12,
          y2: 1,
          containLabel: true
        },
        series: [
          {
            name: '上床时间',
            data: series_data0,
            type: 'scatter',
            symbol: 'circle',
            symbolSize: [6 , 6],
            itemStyle: {
              normal: {
                color: '#FF7186'
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: 'red'
            },
            markArea: {
              itemStyle: {
                color: '#FF718630'
              },
              data: scatter_interval1
            }
          },
          {
            name: '入睡时间',
            data: series_data1,
            type: 'scatter',
            symbol: 'circle',
            symbolSize: [6 , 6],
            itemStyle: {
              normal: {
                color: '#FFB971'
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: 'red'
            },
            markArea: {
              itemStyle: {
                color: '#FAAB6230'
              },
              data: scatter_interval2
            }
          },
          {
            name: '醒来时间',
            data: series_data2,
            type: 'scatter',
            symbol: 'circle',
            symbolSize: [6 , 6],
            itemStyle: {
              normal: {
                color: '#44D7B6'
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: '#FF7186'
            },
            markArea: {
              itemStyle: {
                color: '#44D7B630'
              },
              data: scatter_interval3
            }
          },
          {
            name: '起床时间',
            data: series_data3,
            type: 'scatter',
            symbol: 'circle',
            symbolSize: [6 , 6],
            itemStyle: {
              normal: {
                color: '#1890FF'
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: 'red'
            },
            markArea: {
              itemStyle: {
                color: '#1890FF30'
              },
              data: scatter_interval4
            }
          }
        ],
        // dataZoom: [
        //   {
        //     type: 'inside',
        //     orient: 'vertical',
        //     start: 100,
        //     maxValueSpan: 6,
        //     minValueSpan: 6,
        //     zoomLock: true,
        //   }
        // ]
      };
      this.myChart_Bar.setOption(optionBar,true);
      window.addEventListener('resize', () => {
        this.myChart_Bar.resize();
      });
      this.$forceUpdate()
    },
    // 公共散点图_夜间离床
    getMyChart_optionSca2(idName, type, olddata){
      let data = olddata
      console.log('散点夜间离床')
      console.log(idName, type, olddata)
      this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
      let xAxis_data = data.xAxis_data
      let yAxis_data = data.yAxis_data
      let series_data = data.series_data
      let scatter_interval = data.scatter_interval


      let optionBar = {
        tooltip: {
          type: 'none',
          axisPointer: { // 十字
            type: 'cross',
            snap: false,
            animation: true,
            label: {
              color: '#FFFFFF',
              backgroundColor: '#5F64E7',
              opacity: 1
            },
            crossStyle: {
              color: '#BCB6E8',
              width: 1
            }
          },
          backgroundColor: "#FFFFFF",
          borderColor: "#ABD7FF",
          borderWidth: 1,
          borderRadius: 5,
          textStyle: {
            color: "#262626",
          },
          confine: true,
          formatter: function (val) {
            console.log(val)
            let value = val.value;
				    return value[1] + ' ' + value[0] + '<br/>' + val.marker + '离床' + value[2] + '分钟';
          }
        },
        xAxis: [
          {
            position: 'top',
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            data: xAxis_data,
          }
        ],
        yAxis: [
          {
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#A5A9BC',
            },
            axisTick: {
              show: false
            },
            inverse: true, // 反转
            data: yAxis_data,
            splitArea: {
              show: true,
              interval: 'auto',
              areaStyle: {
              }
            }
          }
        ],
        grid: {
          x: 12,
          y: -1,
          x2: 12,
          y2: 1,
          containLabel: true
        },
        series: [
          {
            name: '离床时长',
            data: series_data,
            type: 'scatter',
            symbol: function (val) {
              if (val[2] <= 5) {
                return 'rect';
              }
              return 'rect';
            },
            symbolSize: function (val) {
              // let allMinutes = 13 * 60.0;
              // let screenWidth = formatterVariable.screenWidth;
              // let singleWidth = screenWidth / allMinutes;
              let singleWidth = 711/720
              if (val[2] <= 5) {
                return [5, 5];
              }
              return [6 + (val[2] * singleWidth) , 6];
            },
            symbolOffset: ['50%', 0],
            itemStyle: {
              normal: {
                color: function (val) {
                  let colors = [
                    'rgb(76,68,195)', 
                    'rgb(81,86,194)', 
                    'rgb(86,104,191)',
                    'rgb(92,122,190)', 
                    'rgb(98,140,188)', 
                    'rgb(106,157,187)', 
                    'rgb(114,175,185)', 
                    'rgb(123,196,183)', 
                    'rgb(132,214,182)',
                    'rgb(139,209,174)',
                    'rgb(146,207,167)',
                    'rgb(158,203,158)',
                    'rgb(171,200,151)',
                    'rgb(186,196,142)',
                    'rgb(200,191,134)',
                    'rgb(219,188,125)',
                    'rgb(233,185,123)',
                  ];
                  let remainder = val.value[2] % 5;
                  if (remainder) {
                    return colors[remainder];
                  } else {
                    return colors[16];
                  }
                }
              },
            },
            showBackground: true,
            markArea: {
              itemStyle: {
                color: '#4E3EC810'
              },
              data: scatter_interval
            }
          }
        ],
        // dataZoom: [
        //   {
        //     type: 'inside',
        //     orient: 'vertical',
        //     start: 100,
        //     maxValueSpan: 6,
        //     minValueSpan: 6,
        //     zoomLock: true,
        //   }
        // ]
      };
      this.myChart_Bar.setOption(optionBar,true);
      window.addEventListener('resize', () => {
        this.myChart_Bar.resize();
      });
      this.$forceUpdate()
    },
    // 时间方法 720个点
    function_get_all_mintues() {
      let hours_data = [19, 20, 21, 22, 23, 0, 1, 2, 3, 4, 5, 6, 7, 8];
      let times = [];
      let minutes = [];
      for (let i = 0; i < hours_data.length; i++) {
        let needTime;
        let item = hours_data[i];
        for (let j = 0; j <= 59; j++) {
          if (item == 19) {
            if (j >= 30) {
              let tempHours = item > 9 ? item : '0' + item;
              let tempMinutes = j > 9 ? j : '0' + j;
              needTime = tempHours + ':' + tempMinutes;
              times.push(needTime);
              minutes.push(item * 60 + j);
            }
          } else if (item == 8) {
            if (j <= 30) {
              let tempHours = item > 9 ? item : '0' + item;
              let tempMinutes = j > 9 ? j : '0' + j;
              needTime = tempHours + ':' + tempMinutes;
              times.push(needTime);
              minutes.push(item * 60 + j);
            }
          } else {
            let tempHours = item > 9 ? item : '0' + item;
            let tempMinutes = j > 9 ? j : '0' + j;
            needTime = tempHours + ':' + tempMinutes;
            times.push(needTime);
            minutes.push(item * 60 + j);
          }
        }
      }
      return times;
    },
    formaTime(minutes) {
      return Math.floor(minutes / 60) + '小时' + (minutes % 60) + '分钟';
    },

    // 选中option时调用
    handleChange_topDate(val){
      console.log(val)
      this.top_date_selval = val;
      this.getNeedFollowByBedId();
    },







    
    // 日历部分
    getActiveDates() {
      var day = new Date();
      var time = day.getTime();
      for (var i = 0; i <= 366; i++) {
        var ms = 24 * 3600 * 1000 * i;
        day.setTime(parseInt(time - ms));
        var y = day.getFullYear().toString();
        var m = (day.getMonth() + 1).toString();
        if (m.length <= 1) m = '0' + m;
        var d = day.getDate().toString();
        if (d.length <= 1) d = '0' + d;
        this.activeDates[i] = y + '-' + m + '-' + d;
      }
      // console.log(this.activeDates);
    },
    // 筛选页面数据
    btnClick(val, valDate, num) {
      console.log(val, valDate, num);
      this.activeType = val;
      this.activeDate = valDate;
      if (val == 3 || val == 4) this.date = valDate;
      if (this.detailsPopup) {
        this.clearCharts();
        if (val == 1) {
          this.getDetailsDataSingle(valDate.slice(0, 7));
        } else {
          this.getH5ManyDaysReport();
        }
      }
    },
    getDayData(value) {
      console.log('udududududududdu');
      for (var i = 0; i < this.effeDates.length; i++) {
        var m = parseInt(this.effeDates[i].slice(5, 7)) - 1;
        var d = parseInt(this.effeDates[i].slice(8, 10));
        if (value.month() == m && value.date() == d) return true;
      }
    },
    getInvalidDates: function(value) {
      for (var i = 0; i < this.invalidDates.length; i++) {
        var m = parseInt(this.invalidDates[i].slice(5, 7)) - 1;
        var d = parseInt(this.invalidDates[i].slice(8, 10));
        if (value.month() == m && value.date() == d) return false;
      }
    },
    panelChange(date) {
      console.log('面板变化回调')
      var dd = date._d;
      var y = dd.getFullYear().toString();
      var m = (dd.getMonth() + 1).toString();
      if (m.length <= 1) m = '0' + m;
      var d = dd.getDate().toString();
      if (d.length <= 1) d = '0' + d;
      var ad = y + '-' + m + '-' + d;
      //console.log(ad);
      if (this.activeDates.indexOf(ad) == -1) {
        var adn = ad;
        adn = parseInt(adn.split('-').join(''));
        var adsn = this.activeDate;
        adsn = parseInt(adsn.split('-').join(''));
        if (adn > adsn) {
          this.btnClick(1, this.activeDates[0], 2);
        } else {
          this.btnClick(1, this.activeDates[this.activeDates.length - 1], 2);
        }
      } else {
        this.btnClick(1, ad, 2);
      }
    },
    changeDate(date) {
      console.log('日期变化回调')
      var dd = date._d;
      var y = dd.getFullYear().toString();
      var m = (dd.getMonth() + 1).toString();
      if (m.length <= 1) m = '0' + m;
      var d = dd.getDate().toString();
      if (d.length <= 1) d = '0' + d;
      var ad = y + '-' + m + '-' + d;
      //console.log(ad);
      this.btnClick(1, ad, 2);
    },
    
  },
};
</script>
<style>
.ant-select-dropdown{
  z-index: 9999999 !important;
}
</style>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';
// .oneExpandCont{
//   padding-top: 10px !important;
// }
.needGZ_TanWrap{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0,0,0,0.5);
  z-index: 999;
  .needGZ_Tan{
    width: 900px;
    height: auto;
    background: #FFFFFF;
    border-radius: 4px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    padding-bottom: 30px;

    min-height: 600px;
    // max-height: 800px;
    // overflow: auto;
  }
}

.needChangeWrap{
  width: 852px;
  height: 54px;
  background: #FFFFFF;
  border-radius: 2px;
  backdrop-filter: blur(8px);
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 10px;
  position: relative;
  display: flex;
  align-items: center;
  .needChangeTip{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1F2635;
  }
}
.needChangeWrap::after{
  width: 4px;
  height: 20px;
  background: #FF7186;
  border-radius: 0px 2px 2px 0px;

  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
// 发现几项值得关注的变化
.gzVaryWrap{
  width: 850px;
  height: 54px;
  background: #FCEBEE;
  border-radius: 4px;
  border: 1px solid #FFB8C3;
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  .gBellImg{
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
  .name{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5E6779;
  }
}

.tan_needGz_portraitWrap ::v-deep {
  .hx_overview{
    width: 100%;
    min-height: 80px;
    height: auto;
    background: #F2F7FC;
    z-index: 999;
    padding-left: 225px;
    padding-right: 15px;
    padding-top: 10px;
    box-sizing: border-box;
    margin-top: 100px;
    border-left: 2px solid #C9E1FC;
    border-right: 2px solid #C9E1FC;
    .bot_adv_tag{
      padding: 1px 10px 1px 5px;
      background: #FFE0E4;
      border-radius: 19px;
      border: 1px solid #FFB8C3;
      backdrop-filter: blur(8px);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5E6779;

      display: inline-block;

      .tanhaoIcon{
        width: 14px;
        height: 14px;
        // margin-right: 3px;
        margin-top: -3px;
      }
    }
  }
  .bot_adv_tag2{
    font-size: 14px;
    padding: 2px 10px;
    background: #E0F0FF;
    border-radius: 19px;
    border: 1px solid #B7DCFE;
    backdrop-filter: blur(8px);
    display: inline-block;
  }
  .refer_comTit2{
    width: 780px;
    height: 52px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1F2635;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid rgba(255,113,134,0.5);
    padding: 0 15px;
    box-sizing: border-box;
    // display: flex;
    align-items: center;
    .reIcon{
      width: 15px;
      height: 15px;
      margin-top: -2px;
      // margin-right: 5px;
    }
  }
  .zxWrap{
    height: 30px;
    position: relative;
    .zxLine{
      width: 750px;
      height: 2px;
      background: #FFD4DA;
      border-radius: 3px;
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      .zxCirWrap{
        flex:1;
        display: flex;
        justify-content: center;
        .zxCir{
          width: 12px;
          height: 12px;
          border-radius: 50%;
          cursor: pointer;
          position: relative;
          .red_cir_noSel{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
          .red_cir_Sel{
            display: none;
          }
          .zxCirFloWin{
            // width: 93px;
            height: auto;
            background: rgba(255,255,255,0.8);
            border: 1px solid #FFDDE2;
            backdrop-filter: blur(2px);
            padding: 15px;
            position: absolute;
            top: -80px;
            left: 50%;
            transform: translateX(-50%);
            display: none;
            .ai_image_change_triangle_d{
              width: 10px;
              height: 8px;
              position: absolute;
              bottom: -6px;
              left: 50%;
              transform: translateX(-50%);
            }
            .time{
              // width: auto;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #262626;
              white-space: nowrap;
            }
            .tCir{
              width: 8px;
              height: 8px;
              background: #FF7186;
              border-radius: 50%;
              margin-right: 3px;
            }
          }
        }
        .zxCir:hover .red_cir_Sel{
          display: block;
        }
        .zxCir:hover .zxCirFloWin{
          display: block;
        }
      }
    }
  }
}


.calDot {
  width: 7px;
  height: 7px;
  border-radius: 10px;
  background-color: #1890ff;
  display: inline-block;
  position: relative;
  top: -5px;
}


// 头部日期下拉框
.dateCont ::v-deep {
  background: #DDEEFF;
  border-radius: 2px;
  border: 1px solid #1890FF;
  outline: 0;
    
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1890FF;
  box-sizing: border-box;
  .ant-select-selection{
    background: #DDEEFF;
    border: 0;
    outline: 0;
  }
}
.dropdown-class ::v-deep .ant-select-dropdown{
    z-index: 9999999 !important;
  }

</style>
